import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import {useSpinner} from "@/shared/composables/SogSpinner";
import apiReport from "@/modules/Report/api";
import apiFile from "@/shared/services/apiFile";
import {ref, watch} from "vue";
import SogProgressInfoComponent from "@/shared/ui/SogProgressInfoComponent.vue";
import {useProgressInfo} from "@/shared/composables/SogProgressInfo";
import SogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogDatePicker from "@/shared/ui/SogDatePicker.vue";
import {addMonths, firstDayOfMonths} from "@/shared/utils/DateUtils";



export default /*@__PURE__*/_defineComponent({
  __name: 'PurchaseSaleReportComponent',
  setup(__props) {


const _spinner = useSpinner()

const _progressId = ref<string|undefined>(undefined);

const {progressInfo:_progressInfo} = useProgressInfo(_progressId,false)
const _from = ref<Date|undefined>(firstDayOfMonths(addMonths(new Date(),-1)))
const _till = ref<Date|undefined>(new Date())

watch((_progressInfo),async () => {
    if (_progressInfo.value?.successful && _progressInfo.value?.resultId) {
      await apiFile.downloadFile(_progressInfo.value.resultId)
      _progressInfo.value = undefined
    }
})


async function onImport() {
  if(!_from.value || !_till.value){
    return
  }
  _spinner.show()
  _progressId.value = await apiReport.purchaseSale(_from.value,_till.value);
  _spinner.hide()
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, null, {
    default: _withCtx(() => [
      _createVNode(SogCardTitle, null, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("Einkauf/Verkauf", -1)
        ]))]),
        _: 1
      }),
      _withDirectives(_createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createVNode(SogProgressInfoComponent, {
            "progress-info": _unref(_progressInfo),
            "show-caption": false
          }, null, 8, ["progress-info"])
        ]),
        _: 1
      }, 512), [
        [_vShow, _unref(_progressInfo)]
      ]),
      _withDirectives(_createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createVNode(SogForm, null, {
            default: _withCtx(() => [
              _createVNode(SogFormField, null, {
                default: _withCtx(() => [
                  _createVNode(SogDatePicker, {
                    modelValue: _from.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_from).value = $event)),
                    placeholder: "Von"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(SogFormField, null, {
                default: _withCtx(() => [
                  _createVNode(SogDatePicker, {
                    modelValue: _till.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_till).value = $event)),
                    placeholder: "Bis",
                    min: _from.value
                  }, null, 8, ["modelValue", "min"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [_vShow, !_unref(_progressInfo)]
      ]),
      _createVNode(SogCardActions, null, {
        default: _withCtx(() => [
          _createVNode(SogCardActionButton, {
            "mdi-icon": "mdi-file-excel",
            onClick: onImport
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" Exportieren ", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})